<template>
  <div class="homeBanner">
    <el-carousel trigger="click" :height="bannerHeight">
      <el-carousel-item v-for="item in banner" :key="item.imgsrc">
        <div v-if="item.url == undefined" class="carouselList">
          <a href="javascript:;" style="display: block"><img :src="item.imgsrc" alt=""></a>
          <div class="shadow">
            <!--我是文字-->
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: 'BannerSmoll',
  props: ['list', 'big'],
  data() {
    return {
      randomimg: Math.floor(Math.random() * 5),
      defaultimg: [
        require('@/static/newsdefault1.jpg'),
        require('@/static/newsdefault2.jpg'),
        require('@/static/newsdefault3.jpg'),
        require('@/static/newsdefault4.jpg'),
        require('@/static/newsdefault5.jpg')
      ],
      bannerHeight: '340px',
      banner: [{ 'imgsrc': require('@/static/four1.jpg') }, { 'imgsrc': require('@/static/four2.jpg') }, { 'imgsrc': require('@/static/four3.jpg') }, { 'imgsrc': require('@/static/four4.jpg') }],
      bannerBig: [{ 'imgsrc': require('@/static/large1.jpg') }, { 'imgsrc': require('@/static/large2.jpg') }, { 'imgsrc': require('@/static/large3.jpg') }, { 'imgsrc': require('@/static/large4.jpg') }]
    }
  },
  mounted() {
    var $this = this
    if (this.big) {
      this.banner = this.bannerBig
    }
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    if (w < 750) {
      if (this.big) {
        this.bannerHeight = w / 1200 * 340 + 'px'
      } else {
        this.bannerHeight = w / 880 * 340 + 'px'
      }
    } else {
      $this.bannerHeight = '340px'
    }
    window.onresize = function() {
      w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (w < 750) {
        if (this.big) {
          this.bannerHeight = w / 1200 * 340 + 'px'
        } else {
          this.bannerHeight = w / 880 * 340 + 'px'
        }
      } else {
        $this.bannerHeight = '340px'
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    ////轮播样式
    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }
    .el-carousel__item carouselList{
      background-position: center center;
    }
    .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: #d3dce6;
    }
    .shadow{
        width: 100%;
        position: absolute;
        height: 40px;
        line-height: 40PX;
        color: red;
        background-color: rgba(0,0,0,.3);
        bottom: 0;
    }
    .carouselList{
      display: block;
      overflow: hidden;
      img{
        width: 100%;
        height: auto;
      }
    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px){
    .shadow{
      background: transparent;
    }
  }
</style>
